module.exports = __webpack_public_path__ + "static/sui-table-basic-0c96fadfbb2753fc7a3778c2463c2a05.png";